<template>
  <div
    class="mobile-core-box"
    :class="{ 'mobile-core-box-about': type === 'about' }"
  >
    <!-- TODO 这里有两个页面用到组件 需要传入不同的padding-top  -->
    <div
      class="mobile-core-content"
      :style="
        type == 'about' ? 'padding-top:19.25rem' : 'padding-top: 9.6875rem'
      "
    >
      <div class="mobile-en-title">VALUES</div>
      <div class="mobile-cn-title">价值观</div>
      <div
        class="mobile-core-item"
        v-for="(item, index) in itemList"
        :key="index"
      >
        <div class="mobile-item-title">{{ item.title }}</div>
        <div class="mobile-item-mark">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "home",
    },
  },
  data() {
    return {
      itemList: [
        {
          title: "经营使命",
          content: "减少企业试错成本让每一个项目都能落地。",
        },
        {
          title: "核心价值观",
          content: "不夸大，说真话，克己慎独，不盲从。",
        },
        {
          title: "企业精神",
          content: "正人做正事，真人真本事。",
        },
        {
          title: "经营理念",
          content: "近悦远来，长期主义，知行合一。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
